export enum BillingIndicator {
  BILLING_START = 'BILLING_START',
  BILLING_END = 'BILLING_END'
}
